import React from "react";
import { Link } from "react-router-dom";

type Props = {};

const Campaignbar = (props: Props) => {
  const path = window.location.pathname;
  return (
    <div className="h-full w-full shrink-0 border-b border-mainColor/30 md:w-[20%] md:border-b-0 md:border-r-2">
      <ul className="mt-2 flex gap-2 overflow-x-auto px-2 py-3 md:mt-4 md:flex-col md:items-center md:justify-center md:gap-4 md:overflow-visible">
        <Link
          to="/campaigns/list/running"
          className={`${
            path.includes("/campaigns/list")
              ? "bg-mainColor/10 text-gray-900 border-l-4 border-mainColor font-semibold"
              : "border-l-4 border-primary bg-white/80"
          } flex shrink-0 rounded-lg p-3 w-full justify-start gap-4 items-center hover:bg-mainColor/20 text-xs transition-all ease-in-out duration-100 whitespace-nowrap`}
        >
          Campaign List
        </Link>
        <Link
          to="/campaigns/template"
          className={`${
            path === "/campaigns/template"
              ? "bg-mainColor/10 text-gray-900 border-l-4 border-mainColor font-semibold"
              : "border-l-4 border-primary bg-white/80"
          } flex shrink-0 rounded-lg p-3 w-full justify-start gap-4 items-center hover:bg-mainColor/20 text-xs transition-all ease-in-out duration-100 whitespace-nowrap`}
        >
          Message Template
        </Link>
      </ul>
    </div>
  );
};

export default Campaignbar;
